module.exports = __webpack_public_path__ + "img/skrill.deb84e84.svg";